import { DEFAULT_LANGUAGE_CODE, LANGUAGES } from './defaultLanguage';

export const LOCALE_STORAGE_KEY = 'tempedge.locale';

export const isSupportedLocale = (code) => LANGUAGES.some((language) => language.code === code);

const getPathLocale = (pathname = '') => {
  const lastSegment = pathname.split('/').filter(Boolean).pop();
  return isSupportedLocale(lastSegment) ? lastSegment : null;
};

/**
 * @param {string} pathname - Current route path.
 * @param {string} locale - Locale the route should carry.
 * @returns {string} The path with its trailing locale segment swapped, or untouched when it has none.
 * @author armandoricosandoval -ai-
 */
export const withPathLocale = (pathname, locale) => {
  const pathLocale = getPathLocale(pathname);
  return pathLocale && pathLocale !== locale ? pathname.replace(new RegExp(`/${pathLocale}/?$`), `/${locale}`) : pathname;
};

const getBrowserLocale = () => {
  const browserLanguage = window.navigator?.language?.slice(0, 2).toLowerCase();
  return isSupportedLocale(browserLanguage) ? browserLanguage : null;
};

const getStoredLocale = () => {
  try {
    const stored = window.localStorage?.getItem(LOCALE_STORAGE_KEY);
    return isSupportedLocale(stored) ? stored : null;
  } catch {
    return null;
  }
};

/**
 * @returns {string} The locale in the URL, else the one the user last picked, else the browser's, else the default.
 * @author armandoricosandoval -ai-
 */
export const readPreferredLocale = () =>
  getPathLocale(window.location?.pathname) || getStoredLocale() || getBrowserLocale() || DEFAULT_LANGUAGE_CODE;

/**
 * @param {string} locale - Locale to remember for the next visit.
 * @author armandoricosandoval -ai-
 */
export const savePreferredLocale = (locale) => {
  try {
    window.localStorage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {}
};
